import { Stack, CircularProgress, Box } from "@mui/material";
import React, { useState } from "react";
import Enumber from "./Enumber";
import EnumberHeader from "./EnumberHeader";
import { useQuery, gql } from "@apollo/client";
import ErrorPage from "../common-component/ErrorPage";

const GET_ENUMBERS = gql`
  query GetENumbers {
    enumbers {
      _id
      Number
      Name
      HalalStatusFirst
      HalalStatusSecond
      Tag
      Type
    }
  }
`;

const EnumberLayout = () => {
  const { loading, error, data } = useQuery(GET_ENUMBERS);
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearch = (value) => {
    setSearchTerm(value);
  };

  const enumbers = data?.enumbers || [];

  const filteredEnumbers = enumbers.filter((enumber) =>
    enumber.Number.toLowerCase().includes(searchTerm.toLowerCase())
  );

  let content;

  if (loading) {
    content = (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "50vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  } else if (error) {
    content = <ErrorPage error={error} />;
  } else {
    content = <Enumber filteredEnumbers={filteredEnumbers} />;
  }

  return (
    <Stack>
      <EnumberHeader onSearch={handleSearch} loading={loading} />
      {content}
    </Stack>
  );
};

export default EnumberLayout;
